import { createAsyncThunk, current } from '@reduxjs/toolkit';
import axios from 'axios';
import { axiosCustom } from '../../../utils/axiosUser';

export const initStateServiceUpdate = {
  serviceUpdate: { data: null, loading: false, error: null },
};

export const serviceUpdate = createAsyncThunk('user/serviceUpdate', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosCustom
    .post(`/service/update`, data)
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerServiceUpdate = {
  [serviceUpdate.pending]: (state) => {
    state.serviceUpdate.loading = true;
  },
  [serviceUpdate.fulfilled]: (state, action) => {
    state.serviceUpdate.loading = false;
    state.serviceUpdate.data = action.payload;
    state.serviceUpdate.error = null;
  },
  [serviceUpdate.rejected]: (state, action) => {
    state.serviceUpdate.loading = false;
    state.serviceUpdate.error = action.payload;
  },
};
